<template>
    <div class="main-container">
        <HeaderElement colorStyle="black-style" />
        <section class="bg-cover" :style="bgImg" id="home">
            <div class="header-banner ">
                <span class="path-text">Rooti / Resources / FAQ</span>
                <div class="row hero-startup faq-text">
                    <div class="col-6">
                        <h1 class="setup-title font-56 mb-20 Semi-bold">
                            A simple patch
                            <br>to a simpler life
                        </h1>
                        <div class="setup-subtitle font-18">
                            The Rooti Rx is developed and designed according to
                            <br>the users' needs. It improves the adaptability of patients
                            <br>and is worthy of patients' trust.
                        </div>
                    </div>
                    <div class="col-6 align-self-end">
                        <div class="startup-thumb">
                            <img src="@/assets/img/Resources/img_system.png" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <CurveShape>
            <template v-slot:bgcolor>
                <path style="fill: #F6F7F9;
                    stroke-miterlimit:10;" d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z" />
            </template>
        </CurveShape>

        <div class="main-banner faq-text">
            <div class="banner-one-sass col-11 col-xl-10 col-xxl-7" style="margin:105px 0 160px 0;">
                <h1 class="text-subtitle Semi-bold font-52" style="width: 60%;">
                    The medical screening revolution starts from the heart.
                </h1>
                <div class="font-18" style="padding-top: 20px;">
                    Rooti Rx is a compact heart monitoring device that can
                    be comfortably worn on your chest during your daily activities.
                    Through extended monitoring, it accurately assesses your health, aiding physicians in identifying
                    conditions such as arrhythmias and sleep apnea for prompt follow-up treatment, preventing potential
                    hidden health issues from leading to serious problems.
                </div>
            </div>

            <div class="col-11 col-xl-10 col-xxl-7 mb-100">
                <h1 class="text-subtitle font-42 Semi-bold mb-20">
                    Rooti Rx system FAQs
                </h1>
                <Accordion :setting="accordion">
                    <template #element-title-0>
                        <div class="title-context font-25 Semi-bold">
                            Can I shower, bathe, or swim while wearing the device?
                        </div>
                    </template>
                    <template #element-content-0>
                        <div class="accordion-content font-18">
                            Rooti Rx has an IP65 waterproof rating, so wearing it while showering is not a problem.
                            Simply dry the device properly after showering.
                        </div>
                        <div class="accordion-content font-18">
                            However, immersing the device in water may affect recording quality and increase the risk of
                            the device detaching. Therefore, we do not recommend activities such as bathing, swimming,
                            or soaking in hot springs while wearing Rooti Rx.
                        </div>
                    </template>

                    <template #element-title-1>
                        <div class="title-context font-25 Semi-bold">
                            Can I exercise or go to work while wearing?
                        </div>
                    </template>
                    <template #element-content-1>
                        <div class="accordion-content font-18">
                            Yes, you can exercise and go to work while wearing the Rooti Rx ECG recorder. The device is
                            designed for continuous monitoring during daily activities, including exercise and work.
                            However, be sure to follow any guidelines provided by medical professionals to ensure
                            optimal performance and accurate readings.
                        </div>
                    </template>

                    <template #element-title-2>
                        <div class="title-context font-25 Semi-bold">
                            Will the skin in the adhesive area feel itchy or uncomfortable while wearing the Rooti Rx?
                        </div>
                    </template>
                    <template #element-content-2>
                        <div class="accordion-content font-18">
                            The experience of wearing the Rooti Rx can vary depending on the wearing duration, weather
                            conditions, and the patient's activity level. If the itchiness or discomfort occurs, avoid
                            scratching and use cold compresses and gentle pressure to relieve the itchiness. If the
                            symptoms persist, please contact a medical professional for further advice.
                        </div>
                    </template>

                    <template #element-title-3>
                        <div class="title-context font-25 Semi-bold">
                            How do I know the Rooti Rx is recording properly while wearing?
                        </div>
                    </template>
                    <template #element-content-3>
                        <div class="accordion-content font-18">
                            Please press the device button shortly. If the LED lights up with a blue light, it indicates
                            that the device is recording properly.
                        </div>
                    </template>

                    <template #element-title-4>
                        <div class="title-context font-25 Semi-bold">
                            Why does the Rooti Rx device keep flashing red light while wearing?
                        </div>
                    </template>
                    <template #element-content-4>
                        <div class="accordion-content font-18">
                            If the device shows a flashing red light, it means that the device's adhesion is poor, and
                            it cannot record a good signal. Please press the electrodes firmly to ensure tight adhesion,
                            and then firmly press the device onto the Rooti Rx Patch. If the LED continues to flash red
                            steadily, please contact the medical professional for further assistance.
                        </div>
                    </template>
                </Accordion>
            </div>

            <div class="banner-one-sass row mb-40 col-10 col-xl-10 col-xxl-7">
                <h1 class="text-subtitle font-42 Semi-bold mb-60">Wearing Guidelines for Rooti Rx</h1>
                <div class="row mb-60">
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_6hr.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                Wearing Guidelines for Rooti Rx
                                After wearing Rooti Rx, please wait for <span class="Semi-bold">6 HOURS</span> before
                                taking a shower
                                orengaging in activities that cause a lot of sweat.
                            </div>
                        </template>
                    </Pricing>
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_wet.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                During the wearing period, you can shower with mild water column.
                                <span class="Semi-bold">DO NOT</span> engage in activities such as bathing, swimming, or
                                soaking in hot springs.
                            </div>
                        </template>
                    </Pricing>
                </div>
                <div class="row mb-60">
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_Lotion.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                During the wearing period, <span class="Semi-bold">DO NOT</span> apply skin care
                                products such as lotions, creams, or
                                essential oils to the adhesive area of the recorder.
                            </div>
                        </template>
                    </Pricing>
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_scratch.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                If you experience symptoms such as skin allergies or itching during the wearing period,
                                please use a cold compress or pressure to relieve the itching, and <span
                                    class="Semi-bold">DO NOT</span> scratch it.
                            </div>
                        </template>
                    </Pricing>
                </div>
                <div class="row">
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_replace.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                During the wearing period, <span class="Semi-bold">DO NOT</span> remove the recorder
                                without prior notification. If the
                                adhesion of the electrodes decreases, please follow the instructions of the healthcare
                                professionals to replace the electrodes.
                            </div>
                        </template>
                    </Pricing>
                    <Pricing class="col">

                        <template #pricing-icon>
                            <div>
                                <img src="@/assets/img/Resources/icon_MRI.png" class="img-fluid faq-pricing" alt="">
                            </div>
                        </template>

                        <template #pricing-word>
                            <div class="text-content font-18">
                                MRI, X-ray, and CT examination is <span class="Semi-bold">NOT</span>
                                allowed during the wearing period.
                                If you need to undergo other examinations, please consult with healthcare professionals
                                first.
                            </div>
                        </template>
                    </Pricing>
                </div>
            </div>

        </div>

        <FooterMain FooterStyle="rooti_bg-footer" />
    </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import CurveShape from '@/components/CurveShape'
import BannerOne from '@/components/Banner/BannerOne'
import Pricing from '@/components/ImageLable/Pricing'
import Accordion from '@/components/Accordion/Accordion.vue'
import FooterMain from '@/components/FooterMain'

export default {
    name: 'FAQ',
    components: {
        HeaderElement,
        CurveShape,
        BannerOne,
        Pricing,
        Accordion,
        FooterMain
    },
    data() {
        return {
            bgImg: {
                backgroundImage: `url(${require('@/assets/img/Resources/BG.webp')})`
            },
            accordion: {
                height: [230, 220, 275, 140, 235],
                number: 5,
                gridMinHeight: 110,
                mainWidth: 70,
            },
        }
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variabls.scss';

.path-text {
    display: block;
    position: relative;
    height: 0px;
    top: 165px;
    color: white;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}


.faq-text {
    .setup-title {
        color: white;
        text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    }

    .setup-subtitle {
        color: white;
    }

    .text-subtitle {
        color: #DB738E;
    }

    .text-content {
        width: 80%;
        padding-top: 10px;
        margin: 0 auto;
    }

    .title-context {
        width: 90%;
        display: flex;
        align-items: center;
    }
}

.hero-startup {
    align-items: center;
    display: flex;
    height: 70vh;
    min-height: 900px;
    max-height: 1300px;
    justify-content: center;

    .startup-thumb {
        bottom: -330px;
        position: relative;
        right: 10%;
        z-index: 3;

        @media (max-width: 1535px) {
            bottom: -270px;
        }
    }
}

.faq-pricing {
    height: 200px;
}
</style>
